// Sender-header helpers shared by the row menu (mark-safe list seeding + add-platform prefill).

/** Extract the full sender address from an email's From header, e.g.
 *  `"Loos | Factuur" <factuur@loos-rotterdam.nl>` → `factuur@loos-rotterdam.nl`. */
export function extractSenderAddress(emailFrom: string | null): string {
  const raw = (emailFrom || '').trim();
  return (raw.match(/<([^>]+)>/)?.[1] || raw).trim().toLowerCase();
}

/** Derive the most stable known-case pattern from an email's From header: its sender domain, else the
 *  raw address. e.g. `"Loos | Factuur" <factuur@loos-rotterdam.nl>` → `loos-rotterdam.nl`. */
export function deriveKnownCaseSender(emailFrom: string | null): string {
  const raw = (emailFrom || '').trim();
  const addr = (raw.match(/<([^>]+)>/)?.[1] || raw).trim().toLowerCase();
  const domain = addr.split('@')[1];
  return (domain || addr || raw).trim();
}
